export default {
    SET_USERS: (state, payload) => state.users = payload,
    SET_USER: (state, payload) => state.user = payload,
    SET_USER_PROJECTS: (state, payload) => state.userProjects = payload,
    SET_NOOP: () => {}
  }